import { createReducer } from '../../../utilities';

import { scope, RESET_UPDATE_LFP_GAME } from '../../../../actions/app/onSite/lfpGame/update';
import {
    REQUEST_FETCH_LFP_GAME,
    SUCCESS_FETCH_LFP_GAME,
    FAIL_FETCH_LFP_GAME,
    REQUEST_CREATE_LFP_GAME,
    SUCCESS_CREATE_LFP_GAME,
    FAIL_CREATE_LFP_GAME,
    REQUEST_ADD_LFP_GAME_MATCH,
    SUCCESS_ADD_LFP_GAME_MATCH,
    FAIL_ADD_LFP_GAME_MATCH
} from '../../../../actions/entities/lfpGame';

const initialLfpGameUpdateState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        id: type === FAIL_FETCH_LFP_GAME ? null : state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

function reset() {
    return initialLfpGameUpdateState
}

export default createReducer(initialLfpGameUpdateState, {
    [REQUEST_FETCH_LFP_GAME]: request,
    [SUCCESS_FETCH_LFP_GAME]: success,
    [FAIL_FETCH_LFP_GAME]: fail,
    [REQUEST_CREATE_LFP_GAME]: request,
    [SUCCESS_CREATE_LFP_GAME]: success,
    [FAIL_CREATE_LFP_GAME]: fail,
    [REQUEST_ADD_LFP_GAME_MATCH]: request,
    [SUCCESS_ADD_LFP_GAME_MATCH]: success,
    [FAIL_ADD_LFP_GAME_MATCH]: fail,
    [RESET_UPDATE_LFP_GAME]: reset
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/lfpGame/update.js